import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SEO from '../components/SEO';
import './TermsAndCondition.css';

const API_BASE = 'https://api.sofiasurgicals.com';

const TermsAndCondition = () => {
    const [policy, setPolicy] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const fetchPolicy = async () => {
            setLoading(true);
            setError(null);
            try {
                const res = await axios.get(`${API_BASE}/api/get-TermsAndCondition`);
                if (!res.data.status) {
                    setError('Terms and Conditions are currently unavailable.');
                    setPolicy(null);
                } else {
                    setPolicy(res.data);
                }
            } catch (err) {
                console.error('Failed to fetch Terms and Conditions:', err);
                setError('Terms and Conditions not found.');
            } finally {
                setLoading(false);
            }
        };

        fetchPolicy();
    }, []);

    if (loading) {
        return (
            <div className="privacy-policy-section">
                <SEO
                    title="Terms & Conditions"
                    description="Read Sofia Surgicals Terms and Conditions for using our website and purchasing orthopaedic implants and instruments."
                    url="/TermsAndCondition"
                />
                <p>Loading Terms and Conditions...</p>
            </div>
        );
    }

    if (error || !policy) {
        return (
            <div className="privacy-policy-section">
                <SEO
                    title="Terms & Conditions"
                    description="Sofia Surgicals Terms and Conditions."
                    url="/TermsAndCondition"
                />
                <p>{error || 'Terms and Conditions not found.'}</p>
            </div>
        );
    }

    return (
        <div className="privacy-policy-section">
            <SEO
                title="Terms & Conditions"
                description="Read Sofia Surgicals Terms and Conditions for using our website, ordering products, and warranty information."
                url="/TermsAndCondition"
            />

            <div className="privacy-policy-content">
                <div
                    dangerouslySetInnerHTML={{ __html: policy?.TermsAndCondition }}
                />
            </div>
        </div>
    );
};

export default TermsAndCondition;